import O1HD from "../../../../engines/gameEngine";
import {LotteryItemEntity} from "./LotteryManager";
import LotteryGGLPrefab from "./LotteryGGLPrefab";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

/**
 * 刮刮乐
 */
@ccclass
export default class LotteryGGLItem extends cc.Component {

    @property(cc.Sprite)
    prizeIcon : cc.Sprite = null;
    @property(cc.Node)
    moneyIcon : cc.Node = null;
    @property(cc.Label)
    lbName : cc.Label = null;
    @property(cc.Node)
    maskNode : cc.Node = null;

    @property(cc.Node)
    judgeImgNode : cc.Node = null;
    @property(cc.Node)
    judgeNameNode : cc.Node = null;
    @property(cc.Node)
    judgeBooleanNode : cc.Node = null;

    @property(cc.Node)
    falseIconNode : cc.Node = null;
    @property(cc.Node)
    trueIconNode : cc.Node = null;

    flagImg : boolean = false;
    flagName : boolean = false;
    flagBoolean : boolean = false;

    private mLotteryItemEntity : LotteryItemEntity;
    private mFlag : boolean;
    private mParentScript : LotteryGGLPrefab;

    onLoad () {
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchstart",this.touchStart.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchmove",this.touchMove.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchcancel",this.touchCancel.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchend",this.touchEnd.bind(this) );
        O1HD.on("LotteryGGLItem.gglMove", this.gglMove.bind(this) , this );
    }

    start () {

    }

    bindData( lotteryGGLPrefab : LotteryGGLPrefab,lotteryItemEntity : LotteryItemEntity , flag : boolean ){
        this.mParentScript = lotteryGGLPrefab;
        this.mLotteryItemEntity = lotteryItemEntity;
        this.mFlag = flag;
        if ( this.mLotteryItemEntity.type == 1 ) {
            //实物
            O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/chineseZodiac/${this.mLotteryItemEntity.defineStr}`,cc.SpriteFrame,(error,assets : cc.SpriteFrame )=>{
                if ( error ){
                    console.log(`LotteryGGLItem找不到图片资源${this.mLotteryItemEntity.defineStr}`);
                }
                this.prizeIcon.spriteFrame = assets;
            });
        }else{
            //钱币奖励
            O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/ggl/guajiang${this.mLotteryItemEntity.imgPathStr}`,cc.SpriteFrame,(error,assets : cc.SpriteFrame )=>{
                if ( error ){
                    console.log(`LotteryGGLItem找不到图片资源${this.mLotteryItemEntity.imgPathStr}`);
                }
                this.node.getChildByName("bg").getComponent(cc.Sprite).spriteFrame = assets;
            });
            if ( this.mLotteryItemEntity.imgPathStr == "1" ) {
                this.prizeIcon.node.parent.active = false;
            }
            this.prizeIcon.node.active = false;
            this.moneyIcon.active = true;
        }
        this.lbName.string = `${this.mLotteryItemEntity.defineStr}`;
    }

    //是否付钱
    hasPay : boolean = false;

    touchStart(e:cc.Event.EventTouch){
        // 检查钱是否充足
        if ( this.hasPay == false ) {
            if ( O1HD.getServices().userSrv.getCoins() >= 1 ){
                O1HD.getServices().userSrv.setCoins( -1 , true ,e.target);
                this.hasPay = true;
            }else{
                O1HD.getModules().uiControlModule.showMessageBox("余额不足" , this.mParentScript.node );
                
                NormalGameManager._instance.openBankPage();
                return;
            }
        }
    }
    touchMove(e:cc.Event.EventTouch){
        if ( this.hasPay ){
            this._addCircle( this.maskNode.convertToNodeSpaceAR( e.getLocation() ) );
            this._checkJudgeNode( e.getLocation() );
        }
    }

    touchCancel(e:cc.Event.EventTouch){

    }
    touchEnd(e:cc.Event.EventTouch){

    }
    maskGraphicsPos1:cc.Vec2[] = [];
    _addCircle(pos:cc.Vec2){
        // @ts-ignore
         this.maskNode.getComponent(cc.Mask)._graphics.circle (pos.x,pos.y, 20 )
        // this.mask._graphics.rect (pos.x-60,pos.y-150,120,300);
        // this.mask._graphics.roundRect (pos.x,pos.y,50,50,10);
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.fill();
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.stroke();
        this.maskGraphicsPos1.push(pos);
    }


    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    _checkJudgeNode ( pos : cc.Vec2 ) {
        if ( this.judgeNameNode.getBoundingBoxToWorld().contains( pos ) ) {
            this.flagName = true;
            this._checkFinish();
            return ;
        }
        if ( this.judgeImgNode.getBoundingBoxToWorld().contains( pos ) ) {
            this.flagImg = true;
            this._checkFinish();
            return;
        }
        if ( this.judgeBooleanNode.getBoundingBoxToWorld().contains( pos ) ) {
            this.flagBoolean = true;
            this._checkFinish();
            return;
        }
    }

    private hasOpenFlag : boolean = false;
    private _checkFinish(){
        if ( this.flagName && this.flagBoolean && this.flagImg && !this.hasOpenFlag ) {
            this.hasOpenFlag = true;
            cc.tween( this.maskNode )
                .to( 0.5 , { opacity : 100 })
                .call( ()=>{
                    this.maskNode.active = false;
                    // 开奖
                    if ( this.mLotteryItemEntity.imgPathStr == "1" ) {
                        this.mParentScript.openPrize( this.mLotteryItemEntity , this.mFlag , this.node );
                    }else{
                        let node = this.mFlag ? this.trueIconNode : this.falseIconNode;
                        node.active = true;
                        node.opacity = 0;
                        cc.tween( node )
                            .to( 1 , { opacity : 255 })
                            .call( ()=>{
                                this.mParentScript.openPrize( this.mLotteryItemEntity , this.mFlag , this.node );
                            } )
                            .start();
                    }
                }).start();
        }
    }

    gglMove( deltaX : number ){
        if ( deltaX > 0 ) {
            if ( this.maskNode.width > 0 ) {
                if ( this.maskNode.width - deltaX > 0 ){
                    this.maskNode.width = this.maskNode.width - deltaX;
                }else{
                    this.maskNode.width = 0;
                    // 开奖
                    this.mParentScript.openPrize(this.mLotteryItemEntity , this.mFlag,this.node );
                }
            }
        }else{
            if ( this.maskNode.width < 398 ) {
                if ( this.maskNode.width - deltaX < 398 ){
                    this.maskNode.width = this.maskNode.width - deltaX;
                }else{
                    this.maskNode.width = 398;
                }
            }
        }
    }
}
